export default __webpack_public_path__ + "assets/images/redflag.0da6776d.png";